import { Service } from 'services'
import { Icon } from 'components'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { DATE_TIME_FORMAT } from 'constants/app'
import { getTideLevelAtTime, selectDepartureWindows } from 'scenarios/calculations'

export const GraphActions = {
    analysis: {
        handleAreaClick: updateAnalysisStartManoeuver,
        // Use centralized tide level calculation from scenarios module
        getTideAtHour: getTideLevelAtTime,
    },
}

async function updateAnalysisStartManoeuver(
    alias,
    range,
    range_shoal,
    selectedOption,
    allDepartureWindows,
    allShoalDepartureWindows,
    isPilotScenario = false
) {
    if (!alias || !range || !Array.isArray(range) || range.length < 1) return
    // range = dock-based (wider, avec pilote)
    const startDock = range[0]
    const endDock = range[range.length - 1]

    // range_shoal = shoal-based (narrower, sans pilote)
    const startShoal = range_shoal[0] ? range_shoal[0].date : null
    const endShoal = range_shoal[range_shoal.length - 1]
        ? range_shoal[range_shoal.length - 1].date
        : null

    // After migration 20251216000000:
    // - *_manoeuver_hour = shoal-based (sans pilote)
    // - *_manoeuver_hour_pilot = dock-based (avec pilote)
    const updateData = {
        alias,
        start_manoeuver_hour: startShoal,
        end_manoeuver_hour: endShoal,
        start_manoeuver_hour_pilot: startDock.date,
        end_manoeuver_hour_pilot: endDock.date,
    }

    // Add the selected option and all departure windows if provided
    if (selectedOption != null) {
        updateData.selected_option = selectedOption
    }
    // departure_windows = shoal-based (sans pilote) for pilot scenarios,
    // or dock-based for non-pilot scenarios (Scenarios 1 & 2)
    const selectedWindows = selectDepartureWindows(
        allDepartureWindows,
        allShoalDepartureWindows,
        isPilotScenario
    )
    updateData.departure_windows = JSON.stringify(selectedWindows)
    // departure_windows_pilot = dock-based (avec pilote)
    if (allDepartureWindows && allDepartureWindows.length > 0) {
        updateData.departure_windows_pilot = JSON.stringify(allDepartureWindows)
    }

    const analysis = await Service.update.analysis(updateData)
    return analysis
}

export function Overlays(props) {
    const { t } = useTranslation()
    const { loading, error } = props

    return (
        <>
            {loading && (
                <div className='overlay loading'>
                    <Icon>loading</Icon>
                </div>
            )}
            {error && !loading && (
                <div className='overlay error'>
                    <Icon>error</Icon>
                    <h3>{t('general.feedback.error.title')}</h3>
                    <p>{t('general.feedback.error.description')}</p>
                </div>
            )}
        </>
    )
}

export function LastUpdated(props) {
    const { t } = useTranslation()
    const { date } = props

    return (
        <small className='last-updated'>
            {t('general.last_updated')} :<b>{date ? moment(date).format(DATE_TIME_FORMAT) : '—'}</b>
        </small>
    )
}
